import { useQuery } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchColumns } from '@/features/asset-detail/api/columnApi';

export const useColumnData = (fullyQualifiedName: string | undefined, enabled: boolean = true) => {
  return useQuery({
    queryKey: assetKeys.columns(fullyQualifiedName || ''),
    queryFn: () => {
      if (!fullyQualifiedName) {
        throw new Error('fullyQualifiedName is required');
      }
      return fetchColumns(fullyQualifiedName);
    },
    enabled: enabled && !!fullyQualifiedName,
    staleTime: 5 * 60 * 1000, // 5분
    gcTime: 10 * 60 * 1000, // 10분
  });
};
